
import { Options, Vue } from "vue-class-component";
import NavHeader from "@/components/NavHeader.vue"; // @ is an alias to /src
import NavHead from "@/components/NavHead.vue"; // @ is an alias to /src

// import { ElConfigProvider } from 'element-plus'
import zhCn from "element-plus/lib/locale/lang/zh-cn";

@Options({
  components: {
    NavHeader,
    // [ElConfigProvider.name]: ElConfigProvider
    // NavHead,
  },
  watch: {
    $route: {
      handler: "onRouteChange",
      immediate: true, // 添加此选项以在组件加载时立即调用处理函数
    },
  },
})
export default class App extends Vue {
  public show_nav = true;
  //  public locale = zhCn

  hideNav() {
    if (/login_new|dmo_perfetto|custom01|hok|awakening-skin|sgame|equipment_management|full|object_memory|hok_domestic/.test(location.pathname)) {
      this.show_nav = false;
    } else {
      this.show_nav = true;
    }
  }

  public onRouteChange(newRoute: any, oldRoute: any) {
    this.hideNav()
  }
  public async mounted() {
    let parentUrl = this.getParentUrl();

    if (parentUrl.indexOf("dworld.woa.com") != -1) {
      this.show_nav = false;
    }
    
    this.hideNav()

    if (window.frames.length != parent.frames.length) {
      this.show_nav = false;
    }

    if (self != top) {
      this.show_nav = false;
    }
    // this.$router.push('/403');
  }

  public getParentUrl() {
    // let url = null;
    let url = "";
    if (parent !== window) {
      try {
        url = parent.location.href;
      } catch (e) {
        url = document.referrer;
      }
    }
    return url;
  }
}
